module.exports = {
      id: "share-youtube-usage",
      viewBox: "0 0 44 45",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#share-youtube",
      toString: function () {
        return this.url;
      }
    }